import axios from './../constants/axios';
import * as types from './../constants/actionTypes';

export function loginSuccess(payload) {
   return { type: types.LOGIN_USER, payload: payload };
}

export function removeUser() {
   return { type: types.REMOVE_USER };
}

export function verifyJwtToken() {
   return function (dispatch) {
      return axios
         .get('sessions/verifyJwtToken/' + getTokenFromSessionStorage())
         .then(function (res) {
            if (res.status === 201) {
               addTokenToSessionStorage(res.data.token);
               dispatch(loginSuccess(res.data.user));
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               removeTokenFromSessionStorage();
            }
         });
   };
}

export function addTokenToSessionStorage(token) {
   localStorage.setItem('token', token);
}

export function removeTokenFromSessionStorage() {
   localStorage.removeItem('token');
}

export function getTokenFromSessionStorage() {
   return localStorage.getItem('token');
}






/** WEBPACK FOOTER **
 ** ./src/actions/sessionActions.js
 **/